import staticRoutes from "./staticRoutes";

//@ @/utils pathToPascalCase
export const pathToPascalCase = path => {
  if (typeof path !== "string") return "";
  const segments = path.replace(/^\//, "").split("/");
  return segments
    .map(segment => segment.charAt(0)?.toUpperCase() + segment.slice(1))
    .join("");
};

function filterRoutes(menu) {
  /**
   * 获取权限菜单数据
   * 用递归的方式遍历菜单，实现组件动态引入、按钮权限设置等功能
   * @param menu JSON: 菜单数据
   * @param businessScope JSON: 用户业务范围
   **/

  if (!menu) {
    return;
  }
  for (let i = 0; i < menu.length; i++) {
    let item = menu[i];
    //遍历权限菜单
    item.meta = {};
    if (item.componentPath) {
      item.component = resolve =>
        require([`../views${item.componentPath}.vue`], resolve); //动态引入页面组件
      item.path = item.menuPage;
      item.icon = item.menuIcon;
      item.name = item.menuName;
      item.meta.permission = true;
      item.meta.componentName = pathToPascalCase(item.menuPage);
      let authActions = item.authActions || [];
      authActions = JSON.parse(JSON.stringify(authActions));
      if (authActions && authActions.length) {
        item.meta.authActions = authActions.map(e => e.componentPath); //设置权限
      }
      if (item.children && item.children.length) {
        let path = "";
        for (let i of item.children) {
          if (i.status !== 3) {
            path = i.menuPage;
            break;
          }
        }
        item.redirect = { path }; //重定向到子目录的第一个路径
        filterRoutes(item.children);
      }
    }
  }
  return menu;
}

export default function getRoutes(routes) {
  /**
   *在动态路由最后添加404，防止页面刷新后找不到页面跳转到404
   **/

  let r = filterRoutes(routes);
  if (Array.isArray(routes)) {
    for (let item of staticRoutes) {
      r.push(item);
    }
    r.push({ path: "*", redirect: "/404" });
  }
  return r;
}
